<template>

    <el-card shadow="always">
      <h1>用户管理</h1>
      <el-button type="primary" @click="showAddDialog = true">添加用户</el-button>

      <!-- 过滤条件区域 -->
      <el-row :gutter="20" style="margin: 20px 0;">
        <el-col :span="6">
          <el-form-item label="锁定状态">
            <el-select v-model="filterParams.is_locked" placeholder="全部" clearable>
              <el-option label="已锁定" :value="true"></el-option>
              <el-option label="未锁定" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审核状态">
            <el-select v-model="filterParams.is_active" placeholder="全部" clearable>
              <el-option label="已审核" :value="true"></el-option>
              <el-option label="未审核" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="到期日期">
            <el-date-picker
              v-model="filterParams.expiration_date"
              type="date"
              placeholder="选择日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              clearable>
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="applyFilters">筛选</el-button>
            <el-button @click="resetFilters">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-table :data="users"
        style="width: 100%"
        border
        stripe
        :default-sort="{ prop: 'id', order: 'descending' }"
        >
          <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="expiration_date" label="到期日期"></el-table-column>
        <el-table-column prop="group.name" label="所属组"></el-table-column>
        <el-table-column label="锁定状态" width="120">
          <template #header>
            <span>锁定状态</span>
          </template>
          <template #default="scope">
            <el-switch
              v-model="scope.row.is_locked"
              active-color="#ff4949"
              inactive-color="#13ce66"
              @change="toggleLockStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="120">
          <template #header>
            <span>审核状态</span>
          </template>
          <template #default="scope">
            <el-switch
              v-model="scope.row.is_active"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="toggleActiveStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button size="small" @click="editUser(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="deleteUser(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加用户弹窗 -->
      <el-dialog title="添加用户" v-model="showAddDialog">
        <el-form :model="newUser" :rules="rules" ref="addForm">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="newUser.username"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="newUser.mobile"></el-input>
          </el-form-item>
          <el-form-item label="到期日期" prop="expiration_date">
            <el-date-picker
              v-model="newUser.expiration_date"
              type="date"
              placeholder="选择日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户组" prop="group_id">
            <el-select v-model="newUser.group_id" placeholder="请选择">
              <el-option
                v-for="group in groups"
                :key="group.id"
                :label="group.name"
                :value="group.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="锁定状态">
            <el-switch v-model="newUser.is_locked"></el-switch>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-switch v-model="newUser.is_active"></el-switch>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="showAddDialog = false">取消</el-button>
          <el-button type="primary" @click="submitAdd">确认</el-button>
        </template>
      </el-dialog>

      <!-- 编辑用户弹窗 -->
      <el-dialog title="编辑用户" v-model="showEditDialog">
        <el-form :model="editingUser" :rules="rules" ref="editForm">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="editingUser.username"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="editingUser.mobile"></el-input>
          </el-form-item>
          <el-form-item label="到期日期" prop="expiration_date">
            <el-date-picker
              v-model="editingUser.expiration_date"
              type="date"
              placeholder="选择日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户组" prop="group_id">
            <el-select v-model="editingUser.group_id">
              <el-option
                v-for="group in groups"
                :key="group.id"
                :label="group.name"
                :value="group.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="锁定状态">
            <el-switch v-model="editingUser.is_locked"></el-switch>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-switch v-model="editingUser.is_active"></el-switch>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="showEditDialog = false">取消</el-button>
          <el-button type="primary" @click="submitEdit">保存</el-button>
        </template>
      </el-dialog>
    </el-card>

</template>

<script>
import axios from 'axios';
import { ElMessage } from 'element-plus';  // 导入 ElMessage

export default {
  data() {
    return {
      users: [],
      groups: [],
      newUser: { username: '', mobile: '', expiration_date: '', group_id: '', is_locked: false, is_active: true },
      editingUser: null,
      showAddDialog: false,
      showEditDialog: false,
      filterParams: {
        is_locked: null,
        is_active: null,
        expiration_date: null
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        group_id: [{ required: true, message: '请选择用户组', trigger: 'change' }]
      }
    };
  },
  created() {
    this.fetchUsers();
    this.fetchGroups();
  },
  methods: {
    async fetchUsers() {
      try {
        // 构建查询参数
        const params = new URLSearchParams();

        // 添加过滤参数
        if (this.filterParams.is_locked !== null && this.filterParams.is_locked !== undefined) {
          params.append('is_locked', this.filterParams.is_locked);
        }
        if (this.filterParams.is_active !== null && this.filterParams.is_active !== undefined) {
          params.append('is_active', this.filterParams.is_active);
        }
        if (this.filterParams.expiration_date !== null && this.filterParams.expiration_date !== undefined) {
          params.append('expiration_date', this.filterParams.expiration_date);
        }

        // 添加分页参数
        params.append('page', 1);
        params.append('page_size', 100); // 设置较大的页面大小以显示所有过滤结果

        const res = await axios.get(`/api/users?${params.toString()}`);
        this.users = res.data.data;
      } catch (error) {
        console.error('获取用户列表失败:', error);
        ElMessage.error('获取用户列表失败');
      }
    },
    async fetchGroups() {
      try {
        const res = await axios.get('/api/groups',{
                headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
        });
        this.groups = res.data;
      } catch (error) {
        console.error('获取用户组列表失败:', error);
        ElMessage.error('获取用户组列表失败');
      }
    },
    // 应用筛选条件
    applyFilters() {
      this.fetchUsers();
      ElMessage.success('筛选条件已应用');
    },
    // 重置筛选条件
    resetFilters() {
      this.filterParams = {
        is_locked: null,
        is_active: null,
        expiration_date: null
      };
      this.fetchUsers();
      ElMessage.success('筛选条件已重置');
    },
    editUser(user) {
      this.editingUser = { ...user };
      this.showEditDialog = true;
    },
    async submitAdd() {
      try {
        await this.$refs.addForm.validate();
        await axios.post('/api/users', this.newUser,{
                 headers: {
                    'Authorization': `Bearer ${this.$store.getters.token}`
                 },
        });
        this.showAddDialog = false;
        this.fetchUsers();
        ElMessage.success('用户添加成功');
      } catch (error) {
        ElMessage.error(error.response.data.detail);
        console.error('添加用户失败:', error);
      }
    },
    async submitEdit() {
      try {
        await this.$refs.editForm.validate();
        await axios.put(`/api/users/${this.editingUser.id}`, this.editingUser, {
            headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },

        });
        this.showEditDialog = false;
        this.fetchUsers();
        ElMessage.success('用户编辑成功');
      } catch (error) {
        ElMessage.error(error.response.data.detail);
        console.error('编辑用户失败:', error);
      }
    },
    async deleteUser(id) {
      try {
        await axios.delete(`/api/users/${id}`);
        this.fetchUsers();
        ElMessage.success('用户删除成功');
      } catch (error) {
        ElMessage.error('删除用户失败');
        console.error('删除用户失败:', error);
      }
    },
    async toggleLockStatus(user) {
      try {
        await axios.put(`/api/users/${user.id}`, { is_locked: user.is_locked });
        this.$message.success('锁定状态更新成功');
      } catch (error) {
        this.$message.error('锁定状态更新失败');
        user.is_locked = !user.is_locked; // 回滚状态
      }
    },
    async toggleActiveStatus(user) {
      try {
        await axios.put(`/api/users/${user.id}`, { is_active: user.is_active });
        this.$message.success('审核状态更新成功');
      } catch (error) {
        this.$message.error('审核状态更新失败');
        user.is_active = !user.is_active; // 回滚状态
      }
    }
  }
};
</script>

<style scoped>
/* 确保样式没有覆盖表头 */
.el-table th {
  background-color: #f0f2f5;
  color: #333;
}

/* 过滤区域样式 */
.el-row {
  margin-bottom: 20px;
}
.el-form-item {
  margin-bottom: 0;
}
</style>